export const CUSTOMER_ACTIVE = 'active'
export const CUSTOMER_INACTIVE = 'inactive'
